import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../types/interfaces';
import { IBrokerAnalyticsUser } from '../../../../types/broker';

export const trackBannerClick = (sc: IJsonQuery, user: IBrokerAnalyticsUser) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'BrokerDealBanner',
    sc,
    user,
  });
};
